import { required, pattern } from 'validx';
import global from 'global';

export const communityMessageValidationSchema = () => {
  const t = global.t;

  return {
    // The schema maps to the fields we are validating.
    Subject: [required({ msg: t('Subject is required') })],
    Message: [required({ msg: t('Message is required') })],
    Tags: [
      (opts) => {
        const tags = opts?.value?.split(',');
        const tagsCount = tags?.length || 0;
        
        return (tagsCount <=3) || 'Maximum three tags';
    },
    (opts) => {
      const tags = opts?.value?.split(',');
      const maxTagLength = 35; //Too long tags will break layout
      const tagTooLong = tags?.some(element => element.length > maxTagLength);
        
      return (!tagTooLong) || `Maximum tag length ${maxTagLength} characters`;
    }],
  };
};
